
import React from 'react';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import {
    Button, Box, Typography, TextField, FormControlLabel, Switch
} from "@mui/material";
import { Space, Row, Col } from "antd";
import { NavLink } from "react-router-dom";

export const LineForm = (props) => {
    const { classes, clsx, myProductdetails, lineForm, lineError, unitMesurementdetails, title, headerView, handleEdit, handleAddMore,
        handleLineSubmit, view, changeHandler, idNamingConversion, customObject, handleProductChange, loader, lineId, productApi } = props;
    return (
        <Box
            className={clsx(classes.customForm, classes.removeUnderline)}
            component="form"
            autoComplete='off'
            onSubmit={(e) => handleLineSubmit(e)}>
            <div className={classes.customFormFlex}>
                <Row gutter={30}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>Line {lineId} Details</Typography>
                    </Col>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Product</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.product?.productName || '---'}</Typography>
                            </> : <AutoCompleteComponent
                                name={["Products"]}
                                heads={[{ 'key': 'productName', 'name': 'Product Name' },
                                { 'key': 'productId', 'name': 'Product ID' }, { 'key': 'universalProduct', 'name': 'UPI Id', 'relation': 'productId' }]}
                                details={myProductdetails}
                                id={idNamingConversion('Product', 'customerProductsLine', 'DropDown')}
                                parentValue={customObject(myProductdetails, lineForm?.productId)}
                                onChange={(data) => handleProductChange(data)}
                                position={"bottom"}
                                searchType={(s) => productApi(s)}
                                parentError={lineError?.productId || false}
                                customClasses={classes.margin10t}
                            />
                        }
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Product ID</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.product?.productId || '---'}</Typography>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Universal Product ID</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.product?.universalProduct?.productId || '---'}</Typography>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Quantity</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.quantity || '---'}</Typography>
                            </> : <TextField autoComplete='one-time-code'
                                className={clsx(classes.margin20t, classes.removeUnderline)}
                                label={["Quantity ", <span key={"Quantity"} className={classes.colorRedRequired}> *</span>]}
                                type={'number'}
                                variant={'standard'}
                                value={lineForm?.quantity || ''}
                                id={idNamingConversion('Quantity', 'customerProductsLine', 'TextField')}
                                error={lineError?.quantity ? true : false}
                                helperText={lineError?.quantity}
                                fullWidth
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    },
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onWheel={(e) => e.target.blur()}
                                onChange={(e) => {
                                    if (e.target.value !== '') {
                                        if (e.target.value < 1) {
                                            changeHandler(e.target.value = 1, 'quantity');
                                        } else {
                                            changeHandler(e.target.value, 'quantity');
                                        }
                                    } else {
                                        changeHandler(e.target.value, 'quantity');
                                    }
                                }}
                            />
                        }
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Unit</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                    {lineForm?.unit?.name}
                                </Typography>
                            </> : <AutoCompleteComponent
                                name={["Unit ", <span key={"Unit"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Unit' },
                                { 'key': 'description', 'name': 'Description' }]}
                                details={unitMesurementdetails}
                                id={idNamingConversion('Unit', 'customerProductsLine', 'DropDown')}
                                parentValue={customObject(unitMesurementdetails, lineForm?.unitId)}
                                onChange={(data) => changeHandler(data, 'unitId')}
                                position={"bottom"}
                                customClasses={classes.margin20t}
                                parentError={lineError?.unitId || false}
                            />
                        }
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Status</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.status ? 'Active' : 'Inactive'}</Typography>
                            </> :
                                <FormControlLabel
                                    classes={{
                                        label: clsx(classes.textFieldLableColorCustom, classes.margin10b, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                    }}
                                    control={<Switch size='small'
                                        className={clsx(classes.customSwitch)}
                                        onChange={(e) => changeHandler(!lineForm?.status, 'status')}
                                    />}
                                    id={idNamingConversion('Status', 'customerProductsLine', 'Radio')}
                                    label="Status"
                                    labelPlacement="top"
                                    checked={lineForm?.status || false}
                                    className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                />
                        }
                    </Col>
                </Row>
            </div>
            <div className={clsx(classes.btnParent)}>
                <Space direction="horizontal" align="center" size={[10, 10]}>
                    {
                        !headerView && <>
                            {
                                view ? <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => handleEdit(false)}>Edit</NavLink> :
                                    <>
                                        <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            type={'submit'}
                                            id={idNamingConversion('Save Update', 'customerProductsLine', 'Button')}
                                            className={clsx(classes.modalBtn, { [classes.loading]: loader })}>
                                            {
                                                title === 'Edit' ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                        {
                                            title === 'Add' && <Button
                                                key="add"
                                                color='primary'
                                                id={idNamingConversion('Add More', 'customerProductsLine', 'Button')}
                                                variant="contained"
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: loader })}
                                                onClick={(e) => handleAddMore(e)}
                                            >Add More</Button>
                                        }
                                    </>
                            }
                        </>
                    }
                </Space>
            </div>
        </Box>
    )
}